import React from 'react';

import CheatSheet from '../components/CheatSheet/CheatSheet';

function DoubleObjectPronouns() {
  return (
    <CheatSheet title='Double Object Pronouns'>
      <p>
        Double Object Pronouns are used when you use both a Direct Object Pronoun and a Indirect
        Object Pronoun in the same sentence.
      </p>
      <p>
        When using Double Object Pronouns, you place the{' '}
        <strong>Indirect Object Pronoun before the Direct Object Pronoun</strong>.
      </p>
      <p>
        Indirect Object Pronouns "le" or "les", <strong>cannot come before</strong> Direct Object
        Pronouns "lo", "la", "los", or "las". You must{' '}
        <strong>change the "le" or "les" to "se"</strong>.
      </p>
    </CheatSheet>
  );
}

export default DoubleObjectPronouns;
